<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import DashboardHome from '@/views/DashboardHome.vue'
import BetaDashboardHome from '@/views/BetaDashboardHome.vue'
import { hasBetaPanelQuery } from '@/utils/panel-variant'

const route = useRoute()
const isBetaPanel = computed(() => hasBetaPanelQuery(route.query))
</script>

<template>
    <BetaDashboardHome v-if="isBetaPanel" />
    <DashboardHome v-else />
</template>
